import React from 'react'
import styled from 'styled-components'

import * as Icons from '@loadsmart/icons'

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 800px;
`

const Icon = styled.a`
  display: inline-block;
  background-color: #fff;
  padding: 10px 15px 5px 15px;
  border-radius: 5px;
  border: 1px solid #ddd;
  margin: 5px;
  text-align: center;
  width: 200px;
  overflow: hidden;
  vertical-align: top;
`

const renderIcon = (id) => {
  const Component = Icons[id]

  return (
    <Icon href="#">
      <Component width="120px" height="120px" />
    </Icon>
  )
}

const Detail = (props) => {
  return <Wrapper>{renderIcon(props.match.params.id)}</Wrapper>
}

export default Detail
